import dayjs from "dayjs";

import Table from "react-bootstrap/Table";

import { OccupationPaginated } from "@/@types/sintegrada/OccupationPaginated";
import {
	dischargeTypeMessages,
	DischargeTypeEnum,
} from "@/utils/enums/sintegrada/occupation/DischargeTypeEnum";
import { TableSkeletons } from "@/components/TableSkeletons";

type Props = {
	paginatedOccupation: OccupationPaginated;
	isLoading?: boolean;
};

export function IndividualTable({ paginatedOccupation, isLoading }: Props) {
	return (
		<Table id="individual-table" bordered>
			<thead>
				<tr className="fw-bold">
					<th>Dt. Admissão</th>
					<th>Nome do paciente</th>
					<th>Dt. Nasc.</th>
					<th>Classificação</th>
					<th>Sexo</th>
					<th>Tipo alta</th>
					<th>Dt. alta</th>
				</tr>
			</thead>

			<tbody>
				{isLoading ? (
					<TableSkeletons numberOfCells={7} numberOfRows={10} />
				) : Boolean(paginatedOccupation?.data?.length) ? (
					paginatedOccupation?.data?.map((occupation, index) => {
						const admissionDate = occupation.admissionDate
							? dayjs(occupation.admissionDate).format("DD/MM/YYYY HH:mm")
							: "N/A";
						const birthdate = occupation.patient.birthdate
							? dayjs(occupation.patient.birthdate).format("DD/MM/YYYY")
							: "N/A";
						const dischargeType =
							dischargeTypeMessages[occupation.dischargeType as DischargeTypeEnum];
						const dischargeDate = occupation.dischargeDate
							? dayjs(occupation.dischargeDate).format("DD/MM/YYYY HH:mm")
							: "N/A";

						return (
							<tr key={`occupation-${index}`}>
								<td>{admissionDate}</td>
								<td className="text-uppercase">{occupation.patient.name}</td>
								<td>{birthdate}</td>
								<td>{occupation.riskClassification?.name}</td>
								<td>{occupation.patient.gender}</td>
								<td>{dischargeType}</td>
								<td>{dischargeDate}</td>
							</tr>
						);
					})
				) : (
					<tr>
						<td colSpan={12} className="text-center text-black-50 fw-bold">
							Nenhum resultado encontrado
						</td>
					</tr>
				)}
			</tbody>
		</Table>
	);
}
